import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a count (10000) into en-US locale (10,000)
 */
@Pipe({
    name: 'countFormat',
    standalone: false
})
export class CountFormatPipe implements PipeTransform {

  transform(value: unknown): unknown {
    if (typeof value !== 'number') {
      return value;
    }
    return new Intl.NumberFormat('en-US').format(value);
  }

}
